import { render, staticRenderFns } from "./NewsStatistics.vue?vue&type=template&id=67ba85a6&"
import script from "./NewsStatistics.vue?vue&type=script&lang=js&"
export * from "./NewsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports